import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import useOrdenNotificaciones from '../cliente/orden/hooks/useOrdenNotificaciones';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import VacationDetailsModal from './VacationDetailsModal';
import VacationRequestsTable from './VacationRequestsTable';
import VacationSummary from './VacationSummary';

const VacationSection = ({ perfil, refreshTrigger = 0 }) => {
    const { token, idCatTipoUsuario } = useToken();
    const { sendPushNotificationRealTime } = useOrdenNotificaciones();
    const jsonToken = decodeJWT(token);
    const idUsuarioToken = jsonToken?.idUsuario;
    const { showErrorToast, showSuccessToast } = useToast();
    const [selectedDaysList, setSelectedDaysList] = useState([]);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [setShowRequestModal] = useState(false);
    const [selectedVacation, setSelectedVacation] = useState(null);
    const [internalRefresh, setInternalRefresh] = useState(0);
    const [calculoVacaciones, setCalculoVacaciones] = useState({
        diasTotales: 0,
        diasUtilizados: 0,
        diasDisponibles: 0,
        aniosServicio: 0,
        desglosePorAnio: []
    });

    const esPropietario = String(idUsuarioToken) === String(perfil?.idUsuario);
    const esAdmin = String(idCatTipoUsuario) === "1";
    const puedeVer = esPropietario || esAdmin;

    function decodeJWT(token) {
        try {
            if (!token) return null;
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                window.atob(base64)
                    .split('')
                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error("Token inválido o mal formado en VacationSection", error);
            return null;
        }
    }

    const loadCalculoVacaciones = async () => {
        try {
            const response = await fetch(`/api/vacaciones/CalcularDiasVacacionesLFT?idUsuario=${perfil.idUsuario}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();
            if (data.iResponseType === 1 && data.detalles) {
                const detalles = JSON.parse(data.detalles);
                const resumen = detalles.table2?.[0] || detalles.Table2?.[0];
                const desglose = detalles.table3 || detalles.Table3 || [];

                if (resumen) {
                    setCalculoVacaciones({
                        diasTotales: resumen.iDiasTotalesAcumulados || 0,
                        diasUtilizados: resumen.iDiasUtilizados || 0,
                        diasDisponibles: resumen.iDiasDisponibles || 0,
                        aniosServicio: resumen.iAniosServicio || 0,
                        proximoAniversario: resumen.dProximoAniversario || null,
                        diasHastaProximoAniversario: resumen.iDiasHastaProximoAniversario || 0,
                        estadoAniosServicio: resumen.vEstadoAniosServicio || '',
                        desglosePorAnio: Array.isArray(desglose) ? desglose.map(d => ({
                            iAnio: d.iAnio || 0,
                            vDescripcionAnio: d.vDescripcionAnio || `Año ${d.iAnio}`,
                            dFechaInicio: d.dFechaInicio || '',
                            dFechaFin: d.dFechaFin || '',
                            iDiasGenerados: d.iDiasGenerados || 0,
                            iDiasUtilizados: d.iDiasUtilizados || 0,
                            iDiasDisponibles: d.iDiasDisponibles || 0,
                            bPeriodoActivo: d.bPeriodoActivo || false,
                            bPeriodoCompletado: d.bPeriodoCompletado || false,
                            decPorcentajeAvance: d.decPorcentajeAvance || 0,
                            vEstadoPeriodo: d.vEstadoPeriodo || 'Desconocido'
                        })) : []
                    });
                }
            }
        } catch (error) {
            console.log("Error al cargar cálculo de vacaciones:", error);
        }
    };

    useEffect(() => {
        if (perfil && perfil.idUsuario) {
            loadCalculoVacaciones();
        }
    }, [perfil, refreshTrigger]);

    const requestVacation = async (fechasAEnviar, motivo = '') => {
        try {
            const fechasFinales = fechasAEnviar && fechasAEnviar.length > 0
                ? fechasAEnviar
                : selectedDaysList.map(day => day.dateString);

            if (!fechasFinales || fechasFinales.length === 0) {
                throw new Error('Debes seleccionar al menos un día para solicitar vacaciones');
            }

            const requestBody = {
                solicitud: {
                    idUsuario: perfil.idUsuario.toString(),
                    fechasSolicitadas: fechasFinales,
                    vMotivoSolicitud: motivo ? motivo.trim() : ""
                }
            };

            const response = await fetch("/api/vacaciones/SolicitarVacaciones", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (data.iResponseType === 1) {
                console.log("[DEBUG] Vacaciones solicitadas con éxito. Data:", data);

                // Enviar notificaciones push a los administradores
                if (data.detalles) {
                    console.log("[DEBUG] data.detalles encontrado:", data.detalles);
                    try {
                        const notificacionesList = JSON.parse(data.detalles);
                        console.log("[DEBUG] Lista de notificaciones parseada:", notificacionesList);
                        if (Array.isArray(notificacionesList)) {
                            notificacionesList.forEach((objNotify) => {
                                console.log("[DEBUG] Enviando push a token:", objNotify.vToken);
                                sendPushNotificationRealTime(objNotify.vToken, objNotify.vCuerpo);
                            });
                        }
                    } catch (e) {
                        console.log("Error parseando notificaciones:", e);
                    }
                } else {
                    console.log("[DEBUG] data.detalles no vino en la respuesta");
                }

                setSelectedDaysList([]);
                setShowRequestModal(false);
                showSuccessToast(data.vMessage || 'Solicitud de vacaciones enviada exitosamente');
                loadCalculoVacaciones();
                setInternalRefresh(prev => prev + 1);
                return true;
            } else {
                throw new Error(data.vMessage || 'Error al procesar la solicitud de vacaciones');
            }
        } catch (error) {
            showErrorToast('Error al procesar la solicitud: ' + error.message);
            return false;
        }
    };

    const handleVacationClick = (vacationData) => {
        setSelectedVacation(vacationData);
        setShowDetailsModal(true);
    };

    return (
        <Card className="mb-3">
            {puedeVer && (
                <>
                    <Card.Header className="bg-light d-flex justify-content-between align-items-center py-2">
                        <h5 className="mb-0">
                            <FontAwesomeIcon icon="umbrella-beach" className="me-2" />
                            Gestión de Vacaciones
                        </h5>
                    </Card.Header>

                    <Card.Body>
                        <Row className="g-3 mb-4">
                            <Col xs={12}>
                                <VacationSummary
                                    calculoVacaciones={calculoVacaciones}
                                    perfil={perfil}
                                    requestVacation={requestVacation}
                                />
                            </Col>
                        </Row>
                        <VacationRequestsTable
                            perfil={perfil}
                            onVacationClick={handleVacationClick}
                            refreshTrigger={refreshTrigger + internalRefresh}
                        />
                    </Card.Body>
                </>

            )}


            <VacationDetailsModal
                show={showDetailsModal}
                onHide={() => setShowDetailsModal(false)}
                employee={selectedVacation}
                onSuccess={loadCalculoVacaciones}
                showActions={false}
            />
        </Card>
    );
};

VacationSection.propTypes = {
    perfil: PropTypes.object.isRequired,
    refreshTrigger: PropTypes.number
};

export default VacationSection;